export class ScenarioItem {
  scenarioId: string;
  scenarioName: string;
  isVisible: boolean;
  instanceId?: string;
  instanceName?: string;
  snapshotId?: string;
  snapshotName?: string;

  constructor(
    scenarioId: string,
    scenarioName: string,
    isVisible: boolean,
    instanceId?: string,
    instanceName?: string,
    snapshotId?: string,
    snapshotName?: string
  ) {
    this.scenarioId = scenarioId;
    this.scenarioName = scenarioName;
    this.isVisible = isVisible;
    this.instanceId = instanceId;
    this.instanceName = instanceName;
    this.snapshotId = snapshotId;
    this.snapshotName = snapshotName;
  }
}
